import { render, staticRenderFns } from "./DescribeLibraryTab.vue?vue&type=template&id=4a569acf&scoped=true&"
import script from "./DescribeLibraryTab.vue?vue&type=script&lang=js&"
export * from "./DescribeLibraryTab.vue?vue&type=script&lang=js&"
import style0 from "./DescribeLibraryTab.vue?vue&type=style&index=0&id=4a569acf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a569acf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VFileInput,VRow,VTextField})
